import { Property } from 'csstype';
import { TFunction } from 'next-i18next';

export interface AssetEarningsData {
  value?: number;
  estimate: number;
  surprise?: number;
  surprise_percentage?: number;
}

export enum TableHeaderEnum {
  Count = 'count',
  FiscalPeriod = 'fiscal_period',
  ReportingDate = 'reporting_date',
  EpsSurprise = 'eps_surprise',
  OneWeek = 'w1',
  TwoWeek = 'w2',
  OneMonth = 'm1',
}

export const gaTableHeaderMapping: Record<
  string,
  'earnings' | 'EPS surprise' | '1W' | '2W' | '1M'
> = {
  [TableHeaderEnum.OneMonth]: '1M',
  [TableHeaderEnum.OneWeek]: '1W',
  [TableHeaderEnum.TwoWeek]: '2W',
  [TableHeaderEnum.EpsSurprise]: 'EPS surprise',
  [TableHeaderEnum.ReportingDate]: 'earnings',
};

interface TableHeaderData {
  name: string;
  type: TableHeaderEnum;
  alignment?: Property.TextAlign;
}

export const getHeadingsData = (
  t: TFunction,
  currency: string
): TableHeaderData[] => {
  return [
    {
      name: t('table.earnings'),
      type: TableHeaderEnum.ReportingDate,
      alignment: 'start',
    },
    {
      name: t('table.epsSurprise', { currency }),
      type: TableHeaderEnum.EpsSurprise,
    },
    {
      name: t('table.oneWeek'),
      type: TableHeaderEnum.OneWeek,
    },
    {
      name: t('table.twoWeek'),
      type: TableHeaderEnum.TwoWeek,
    },
    {
      name: t('table.oneMonth'),
      type: TableHeaderEnum.OneMonth,
    },
  ];
};
